import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import RetailerLayout from "@/components/RetailerLayout";

export default function RetailerEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/retailer/enquiries")
      .then((r) => setItems(r.data.enquiries || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <RetailerLayout>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-6" data-testid="enquiries-page">
        <h1 className="font-display font-bold text-2xl text-slate-900 mb-1">Customer enquiries</h1>
        <p className="text-sm text-slate-500 mb-4">
          All messages are platform-mediated. Phone numbers, emails and links are stripped
          automatically to protect you and the shopper.
        </p>
        {loading ? (
          <div className="text-slate-500">Loading…</div>
        ) : items.length === 0 ? (
          <div className="bg-white border border-slate-200 rounded-xl p-8 text-center text-slate-600">
            No enquiries yet.
          </div>
        ) : (
          <div className="grid gap-3">
            {items.map((e) => (
              <div
                key={e.id}
                className="bg-white border border-slate-200 rounded-xl p-4"
                data-testid={`enquiry-row-${e.id}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0 flex-1">
                    <div className="text-xs text-slate-500 font-mono">{e.listing_reference}</div>
                    <div className="font-semibold text-slate-900">{e.question}</div>
                    {e.other_text && (
                      <div className="text-sm text-slate-700 mt-1 whitespace-pre-line">{e.other_text}</div>
                    )}
                    <div className="text-xs text-slate-500 mt-2">
                      {e.customer_name} · {new Date(e.created_at).toLocaleString("en-GB")}
                    </div>
                  </div>
                  <span className="text-xs bg-[#2A5A3B]/10 text-[#2A5A3B] rounded-full px-2 py-0.5 font-semibold">
                    New
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </RetailerLayout>
  );
}
